import styled from "styled-components";
import { TailSpin } from "react-loader-spinner";

export default function LoadingIcon() {
  return <TailSpin color="#6d6d6d" width="35px"/>;
}
